import { ExaminationInfoQuery } from "@generated/graphql";
import { getTrialLinkString } from "helpers/index";
import useIsCreate from "hooks/useIsCreate";
import { getTestingBaseFormData } from "pages/Testing/utils/form.utils";
import qs from "qs";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { CompetencyMapOptionList, ScenarioOption } from "../../types";
import { GroupAndOpenInfoInputs } from "../types";

const useInitBaseExaminationForm = (
  examination: ExaminationInfoQuery["examination"] | undefined,
  competencyMaps: CompetencyMapOptionList,
  scenarios: ScenarioOption[] | undefined
): GroupAndOpenInfoInputs => {
  const [searchParams] = useSearchParams();
  const isCreate = useIsCreate();
  const params = useMemo(() => qs.parse(searchParams.toString()), [searchParams]);
  const { competencyMapId, scenarioId } = params as unknown as { competencyMapId?: string; scenarioId?: string };

  const competencyMap =
    isCreate && competencyMapId
      ? competencyMaps?.find((map) => map.id === competencyMapId)
      : examination?.competencyMap && {
          ...examination.competencyMap,
          id: examination.competencyMap.originalCompetencyMapId || "",
        };
  const scenario =
    isCreate && scenarioId ? scenarios?.find((item) => item.id === scenarioId) : examination?.scenario || undefined;
  const assessmentLink = examination ? getTrialLinkString(examination) : undefined;

  return {
    ...getTestingBaseFormData(examination?.id, examination, competencyMap, scenario),
    link: assessmentLink,
    candidatesFile: undefined,
    sendReminder: examination?.sendReminder,
    reminderSchedule: examination?.reminderSchedule,
  };
};

export default useInitBaseExaminationForm;
